import {
  CheckmarkCircleFilled,
  InfoFilled,
  DismissCircleFilled,
} from "@fluentui/react-icons";
import { TransactionStatusEnum } from "enum/common";

export const ShowStatus = ({ status }: statusProps) => {
  switch (status) {
    case TransactionStatusEnum.SUCCESS:
    case TransactionStatusEnum.MAPPED:
      return (
        <h2
          color="blue-gray"
          className="font-normal items-center flex flex-row"
        >
          <div>
            <CheckmarkCircleFilled
              fontSize={20}
              className="text-green mb-[2px]"
            />
          </div>
          <div className="ml-1 text-green">Success</div>
        </h2>
      );

    case TransactionStatusEnum.FAILED:
      return (
        <h2
          color="blue-gray"
          className="font-normal items-center flex flex-row"
        >
          <div>
            <DismissCircleFilled
              fontSize={20}
              className="text-failed mb-[2px]"
            />
          </div>
          <div className="ml-1 text-failed">Failed</div>
        </h2>
      );

    case TransactionStatusEnum.PENDING:
      return (
        <h2
          color="blue-gray"
          className="font-normal items-center flex flex-row"
        >
          <div>
            <InfoFilled fontSize={20} className="text-warning mb-[2px]" />
          </div>
          <div className="ml-1 text-warning self-center">Pending</div>
        </h2>
      );
    default:
      return null;
  }
};
